import React from 'react';

import PageContainer from '@/components/layout/PageContainer';

import AnonymousReportCard from '@/modules/dashboard/components/AnonymousReportCard';
import ContactCard from '@/modules/dashboard/components/ContactCard';
import DocumentsCard from '@/modules/dashboard/components/DocumentsCard';
import FavoriteBusLinesCard from '@/modules/dashboard/components/FavoriteBusLinesCard';
import NpsResearch from '@/modules/dashboard/components/NpsResearch';

const CompanyDashboard: React.FC = () => {
  return (
    <PageContainer title="Dashboard">
      <div className="mb-6">
        <NpsResearch />
      </div>
      <div className="flex flex-col lg:flex-row flex-wrap gap-6">
        <DocumentsCard className="flex-1 min-w-80 h-min" />

        <div className="flex flex-col flex-1 gap-6">
          <FavoriteBusLinesCard />
          <ContactCard className="flex-1 h-min" />
          <AnonymousReportCard className="hidden flex-1 h-min" />
        </div>
      </div>
    </PageContainer>
  );
};

export default CompanyDashboard;
